import { FormControl } from '@angular/forms';

export function noWhitespaceValidator(control: FormControl) {
  return (control.value || '').trim().length > 0 ? null : { required: true };
}
